// extracted by mini-css-extract-plugin
export var questions = "styles-module--questions--UxqwR";
export var recaptchaLoaded = "styles-module--recaptchaLoaded--yka1S";